import { createAsyncThunk } from '@reduxjs/toolkit'
import { ThunkConfig } from '../../../../types/store'
import {
    alertErrorMessage,
    throwSuccessMessage,
} from '../../../../utils/Errors'
import { getUrlWithVersion } from '../../../../api/api'

export const quickAccessRemoveProduct = createAsyncThunk<
    { guid: string },
    { guid: string },
    ThunkConfig<string>
>('productsSlice/quickAccessRemoveProduct', async (args, thunkAPI) => {
    const {
        extra: { api },
        rejectWithValue,
    } = thunkAPI

    const { guid } = args

    try {
        await api.delete(
            getUrlWithVersion(`/users/current/quick_access/${guid}`)
        )
        throwSuccessMessage('Product removed from quick access!')

        return { guid }
    } catch (e) {
        alertErrorMessage(e)
        return rejectWithValue('Failed to remove product from quick access')
    }
})
